<template>
  <header class="painel-header">
    <h1 class="painel-header__title">Painel de Controle | Sistemas de Telechamada</h1>
    <button type="button" class="painel-header__logout" @click="handleLogout">
      Sair
    </button>
  </header>
</template>

<script>
import { logout } from '../service/auth.service';

export default {
  name: 'PainelHeader',

  methods: {
    handleLogout() {
      logout();
      this.$router.push('/painel');
    }
  }
};
</script>

<style scoped>
.painel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  padding: 0 2rem;
  color: #fff;
  background-color: #005b61;
}

.painel-header__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.painel-header__logout {
  padding: 0.5rem 1.25rem;
  border: 1px solid #fff;
  border-radius: 6px;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.painel-header__logout:hover {
  color: #005b61;
  background: #fff;
}
</style>
